import { render, staticRenderFns } from "./specialVideo_detail.vue?vue&type=template&id=5b8b747e&scoped=true"
import script from "./specialVideo_detail.vue?vue&type=script&lang=js"
export * from "./specialVideo_detail.vue?vue&type=script&lang=js"
import style0 from "./specialVideo_detail.vue?vue&type=style&index=0&id=5b8b747e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b747e",
  null
  
)

export default component.exports